module.exports = __webpack_public_path__ + "catalog/items/firesafety/Fire-Suppression-System/Fire-Suppression-System.svg";